<template>
    <div class="talkrecord-list-root">
        <div id="record-list-field" class="talkrecord-list-panel">
            <div v-if="displayInitialNotice" class="notalkrecord">
                <div v-if="this.selected.length == 0">
                    <span v-html="$t('message.hint_menu_talkHistory1')"></span>
                    <br>
                    <hr class="hint-hr">
                    <br>
                    <table class="hint-table" align="center">
                        <tr>
                            <td class="hint-table-title" v-t="'message.hint_menu_talkHistory2'"></td>
                        </tr>
                        <tr>
                            <td class="hint-table-item" v-t="'message.hint_menu_talkHistory3'"></td>
                        </tr>
                        <tr>
                            <td class="hint-table-title" v-t="'message.hint_menu_talkHistory4'"></td>
                        </tr>
                        <tr>
                            <td class="hint-table-item" v-t="'message.hint_menu_talkHistory5'"></td>
                        </tr>
                    </table>
                </div>
            </div>
            <template v-else>
                <div class="object-titlebox">
                    <div class="object-titlebox-right" style="padding-top:5px;padding-bottom:5px">
                    <span v-if="talkrecords.length == 0">
                        <el-tooltip effect="light" placement="top-start" >
                            <div slot="content" style="text-align:left" v-t="'message.info_no_talk_record_list'"></div>
                            <button class="transparent-button-disabled" type="button"><img style="opacity:0.6" src="../../assets/icon_download.svg"/><span v-t="'message.action_talkList_export'"></span></button>
                        </el-tooltip>
                    </span>
                        <span v-else>
                        <button class="transparent-button" type="button" v-on:click="exportToCSV()"><img
                            src="../../assets/icon_download.svg"/><span class="normal-command-text"
                                                                        v-t="'message.action_talkList_export'"></span></button>
                    </span>
                        <el-select v-model="selectedLanguageIndex" style="width:130px;padding-right:15px" @change="handleChangeLanguage()" filterable>
                            <div v-for="language in languageList">
                                <div v-if="$i18n.locale == 'ja'">
                                    <el-option style="font-size:12px" :label="language.description" :value="language.value"></el-option>
                                </div>
                                <div v-else>
                                    <el-option :label="language.description_en" :value="language.value"></el-option>
                                </div>
                            </div>
                        </el-select>
                        <button class="transparent-button" type="button" v-on:click="refreshList()"><img src="../../assets/icon_load.svg"/><span class="normal-command-text" v-t="'message.action_talk_refresh'"></span></button>
                    </div>
                </div>
                <div class="talkrecord-table-wrap">
                    <el-table ref="talkRecordsTable"
                          v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                          :empty-text="getEmptyTalkRecordText()"
                          :row-class-name="checkHiddenData"
                          :cell-class-name="getCellClassName"
                          :data="talkrecords"
                          :default-sort="{prop: 'startTime', order: 'ascending'}"
                          height="100%" style="width: 100%" header-row-class-name="talkrecord-header">
                <el-table-column prop="startTime" :label="$t('message.item_talk_start_datetime')" sortable width="170">
                    <template slot-scope="scope">
                        {{ scope.row.startTime.toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_talker')" prop="displayName" sortable :sort-method="sortByDisplayName" header-align=left align=left width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.displayName != null">
                            <span v-if="scope.row.displayName.length <=8">{{ scope.row.displayName }}</span>
                            <span v-else>{{ scope.row.displayName.substring(0,8) }}...</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_type')" prop="type" header-align=left align=left width="80">
                    <template slot-scope="scope">
                        <span v-if="isVoiceReport(scope.row.type, scope.row.attributes)" v-t="'message.item_type_voice_report'"/>
                        <span v-else-if="isMapTalk(scope.row.type, scope.row.attributes)"
                              v-t="'message.item_type_map'"/>
                        <span v-else-if="scope.row.type === Const.TALK_RECORD_VOICE" v-t="'message.item_type_voice'"/>
                        <span v-else-if="isVideo(scope.row.type, scope.row.data)" v-t="'message.item_type_video'"/>
                        <span v-else-if="isImage(scope.row.type, scope.row.data)" v-t="'message.item_type_image'"/>
                        <span v-else-if="isPDF(scope.row.type, scope.row.data)">PDF</span>
                        <span v-else-if="scope.row.type === Const.TALK_RECORD_TEXT" v-t="'message.item_type_text'"/>
                        <span v-else-if="scope.row.isMml" v-t="'message.item_type_melody_stamp'"/>
                        <span v-else v-t="'message.item_type_etc'"/>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_text')" prop="data" header-align=left align=left>
                    <template slot-scope="scope">
                        <span v-if="isVideo(scope.row.type, scope.row.data) || isImage(scope.row.type, scope.row.data)">
                            <span
                                class="talkrecord-thumbnail-wrapper"
                                @click="getBinaryData(scope.row)"
                            >
                                <img
                                    class="talkrecord-thumbnail"
                                    :src="getMediaThumbnailSrc(scope.row)"
                                    alt="thumbnail"
                                    @error="onMediaThumbnailError(scope.row)"
                                />
                                <span
                                    v-if="isVideo(scope.row.type, scope.row.data) && hasLoadedThumbnail(scope.row)"
                                    class="talkrecord-thumbnail-overlay"
                                ></span>
                                <button
                                    v-if="isVideo(scope.row.type, scope.row.data) && hasLoadedThumbnail(scope.row)"
                                    type="button"
                                    class="talkrecord-thumbnail-play"
                                    @click.stop="getBinaryData(scope.row)"
                                >
                                    <img src="../../assets/icon_movie_thumbnail_overlay.svg" />
                                </button>
                            </span>
                        </span>
                        <span v-else-if="scope.row.data != null && ((scope.row.type == Const.TALK_RECORD_VOICE) || (scope.row.type == Const.TALK_RECORD_TEXT) || (scope.row.type == Const.TALK_RECORD_ONLOAD_DATA))">
                            <span v-if="scope.row.data.length <= 16">{{ scope.row.data }}</span>
                            <span v-else>{{ scope.row.data.substring(0,16) }}...</span>
                        </span>
                        <span v-else>
                            －
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.action_talk_play')" header-align=center align=center width="65">
                    <template slot-scope="scope">
                        <button v-if="scope.row.type == Const.TALK_RECORD_VOICE" class="item-record-button" @click="clickPlay(scope.row, $event)">
                            <img src="../../assets/icon_start.svg"></img>
                        </button>
                        <button v-if="scope.row.type == Const.TALK_RECORD_BINARY" class="item-record-button" @click="getBinaryData(scope.row)">
                            <img src="../../assets/icon_start.svg"></img>
                        </button>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_time')" prop="duration" header-align=left align=left width="85">
                    <template slot-scope="scope">
                        <span v-if="scope.row.duration != null && ((scope.row.type == Const.TALK_RECORD_VOICE) || isVideo(scope.row.type, scope.row.data))">
                            <span>{{ convertMillsec(scope.row.duration) }}</span>
                        </span>
                        <span v-else>
                            －
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.action_talk_detail')" header-align=center align=center width="65">
                    <template slot-scope="scope">
                        <button class="item-record-button" @click="showDetailWindow(scope.row)">
                            <img src="../../assets/icon_detail.svg"></img>
                        </button>
                    </template>
                </el-table-column>
                    </el-table>
                </div>
            </template>
        </div>
        <audio id="record-player">
            <source v-bind:src="playSource" type="audio/ogg"></source>
        </audio>

        <TalkrecordDetail
            v-if="showDetail"
            :record="detailShownRecord"
            :selected=this.selected
            :isTalkgroup=this.isTalkgroup
            :appData="appData"
            @cancel="showDetail=false"
        />
        <VideoPlayer
            v-if="showVideoPlayer"
            :playVideoSrc="playVideoSrc"
            @close="showVideoPlayer=false"
        />
        <ImageViewer
            v-if="showImageViewer"
            :imageSrc="imageSrc"
            @close="showImageViewer=false"
        />
        <PDFViewer
            v-if="showPDFViewer"
            :pdfSrc="pdfSrc"
            @close="showPDFViewer=false"
        />
     </div>
</template>

<script>
import server from "../ServerApi.js";
import TalkrecordDetail from "./TalkrecordDetail.vue"
import commonUtil from '../commonutil.js';
import constants from '../constants.js';
import VideoPlayer from "../VideoPlayer.vue"
import ImageViewer from "../ImageViewer.vue"
import {FEATURE_C2C_AUDIT_LOG, FEATURE_C2C_MAP_TALK} from "@/components/feature_toggles/feature_toggle";
import PDFViewer from "@/components/PDFViewer.vue";

export default {
    data() {
        return {
            Const: {
                TALK_RECORD_VOICE: constants.TALK_RECORD_VOICE,
                TALK_RECORD_TEXT:  constants.TALK_RECORD_TEXT,
                TALK_RECORD_BINARY: constants.TALK_RECORD_BINARY,
                TALK_RECORD_ONLOAD_DATA: constants.TALK_RECORD_ONLOAD_DATA
            },
            showVideoPlayer: false,
            showImageViewer: false,
            notSupportAgent: false,
            talkrecords: [],
            thumbnailUrlByData: {}, // { [data:string]: string }
            thumbnailRequestNonce: 0,
            thumbnailFailedByData: {}, // { [data:string]: true }
            playSource: '',
            showDetail: false,
            detailShownRecord: null,
            languageList: null,
            selectedLanguageIndex: 0,
            playVideoSrc: null,
            imageSrc: null,
            timer: null,
            loading: false,
            displayInitialNotice: true,
            pdfSrc: "",
            showPDFViewer: false,
        };
    },
    methods: {
        initTalkRecordListPanel: function() {
            this.currentPlayingButton = null;
            this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
            this.selectedLanguageIndex = this.languageIndex;
            this.displayInitialNotice = true;
        },
        getList: function(refresh) {
            let audio = document.getElementById('record-player');
            audio.pause();

            if (!isNaN(audio.duration)) {
                // error occurred if access to currentTime before meta data of audio is loaded on IE11.
                audio.currentTime = 0;
            }

            if (this.selected.length === 0) {
                this.talkrecords = [];
                return;
            }

            if (!this.isTalkgroup && this.selected.length !== 2) {
                this.talkrecords = [];
                return;
            }

            let self = this;

            let localFromTime = this.startTime.split(':')
            let localToTime = this.endTime.split(':')
            let localFromDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localFromTime[0], localFromTime[1]);
            let localToDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localToTime[0], localToTime[1]);

            let utcFromDateStr = localFromDate.toISOString();
            let utcToDateStr = localToDate.toISOString();

            let endpoint;
            let input;

            this.loading = true;
            this.displayInitialNotice = false;
            if (this.isTalkgroup) {
                endpoint = '/gettalkrecords';
                input = {
                    talkgroupTenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    fromDate: utcFromDateStr,
                    toDate: utcToDateStr,
                    interestLanguageIndex: this.selectedLanguageIndex
                }
            } else {
                endpoint = '/getpeertalkrecords';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    fromDate: utcFromDateStr,
                    toDate: utcToDateStr,
                    interestLanguageIndex: this.selectedLanguageIndex
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.talkrecords = this.mergeTalkrecords(res.data.talkRecords, self.selectedLanguageIndex);
                            this.getThumbnailUrls(this.talkrecords);
                            self.setTimer();
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            this.talkrecords = [];
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                            self.loading = false;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getList"));
                            self.loading = false;
                            return;
                    }
                    if (refresh) {
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                    }
                })
                .catch( function ( error ) {
                    self.loading = false;
                    commonUtil.putExceptionErrorMessage(self, "getList", error);
                });
        },
        refreshList: function() {
            return this.getList(false);
        },
        mergeTalkrecords(talkrecords, interestLanguageIndex) {
            let mergedTalkrecords = [];

            if (talkrecords.length === 0) {
                return mergedTalkrecords;
            }

            let id = talkrecords[0].id;
            let startTime = new Date(talkrecords[0].startTime);
            let displayName = talkrecords[0].displayName;
            let otherLanguages = [];
            let duration = null;
            let type = talkrecords[0].type;  // Voice + Text : 0, Blob : 2, Code : 3, Max : 4
            let data = null;
            let isMml = false;
            let hidden = talkrecords[0].hidden;
            let attributes = talkrecords[0].attributes ?? constants.TALK_RECORD_ATTRIBUTE_DEFAULT;

            for (let i = 0; i < talkrecords.length; i++) {
                let talkrecord = talkrecords[i];
                if ((talkrecord.type !== constants.TALK_RECORD_VOICE) && (talkrecord.type !== constants.TALK_RECORD_TEXT)
                    && (talkrecord.type !== constants.TALK_RECORD_BINARY) && (talkrecord.type !== constants.TALK_RECORD_ONLOAD_DATA)
                ) {
                    continue;
                }
                if (id !== talkrecord.id) {
                    mergedTalkrecords.push({
                        id: id,
                        startTime: startTime,
                        displayName: displayName,
                        interestLanguageIndex: interestLanguageIndex,
                        otherLanguages: otherLanguages,
                        duration: duration,
                        type: type,
                        data: data,
                        isMml: isMml,
                        hidden: hidden,
                        attributes: attributes,
                    })
                    startTime = new Date(talkrecord.startTime);
                    displayName = talkrecord.displayName;
                    otherLanguages = [];
                    duration = null;
                    type = talkrecord.type;
                    data = talkrecord.data;
                    hidden = talkrecord.hidden;
                    attributes = talkrecord.attributes;
                }

                id = talkrecord.id;

                // update isMml if condition met
                isMml = false;
                switch (talkrecord.type) {
                    case constants.TALK_RECORD_VOICE: // Voice
                        duration = talkrecord.duration;
                        type = talkrecord.type;
                        attributes = talkrecord.attributes ?? constants.TALK_RECORD_ATTRIBUTE_DEFAULT;
                        break;
                    case constants.TALK_RECORD_TEXT: // Text
                        if (talkrecord.languageIndex === interestLanguageIndex) {
                            data = talkrecord.data;
                        } else {
                            otherLanguages.push(talkrecord.languageIndex);
                        }
                        break;
                    case constants.TALK_RECORD_ONLOAD_DATA: // Onload data
                        let splitted = talkrecord.data.split(':');
                        isMml = (splitted[0].toUpperCase() == 'MML');
                        data = splitted[1].split('"').join("'");
                        break;
                    case constants.TALK_RECORD_BINARY: // Video
                        if (this.isVideo(talkrecord.type, talkrecord.data)) {
                            duration = talkrecord.duration;
                            data = talkrecord.data;
                            type = talkrecord.type;
                        } else if (this.isImage(talkrecord.type, talkrecord.data)) {
                            data = talkrecord.data;
                            type = talkrecord.type;
                        }
                        break;
                    default:
                        data = talkrecord.data;
                        type = talkrecord.type;
                }
            }

            mergedTalkrecords.push({
                id: id,
                startTime: startTime,
                displayName: displayName,
                interestLanguageIndex: interestLanguageIndex,
                otherLanguages: otherLanguages,
                duration: duration,
                type: type,
                data: data,
                isMml: isMml,
                hidden: hidden,
                attributes: attributes,
            })
            return mergedTalkrecords;
        },
        /**
         * Batch-request thumbnail URLs for the provided talk records and cache results in `thumbnailUrlByData`.
         */
        getThumbnailUrls(talkrecords) {
            const records = Array.isArray(talkrecords) ? talkrecords : [];
            const thumbnailsToRequest = [];

            for (const talkrecord of records) {
                if (!talkrecord || talkrecord.id == null) continue;
                if (!talkrecord.data) continue;
                if (!this.isVideo(talkrecord.type, talkrecord.data) && !this.isImage(talkrecord.type, talkrecord.data)) continue;
                if (this.thumbnailUrlByData && this.thumbnailUrlByData[talkrecord.data]) continue;
                thumbnailsToRequest.push({ id: talkrecord.id, data: talkrecord.data });
            }

            if (thumbnailsToRequest.length === 0) return;

            const requestNonce = ++this.thumbnailRequestNonce;
            const endpoint = '/getthumbnailurl';

            const input = this.isTalkgroup ? {
                talkgroupId: this.selected[0].data.id,
                recordInfoList: thumbnailsToRequest,
            } : {
                userId1: this.selected[0].data.id,
                userId2: this.selected[1].data.id,
                recordInfoList: thumbnailsToRequest,
            };

            server.post(endpoint, input)
                .then((res) => {
                    if (requestNonce !== this.thumbnailRequestNonce) return;
                    const payload = res && res.data ? res.data : null;
                    if (payload && payload.status === constants.STATUS_ERROR_TOO_MANY_ENTRY) {
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_thumbnail_count_exceeds_max").replace("{code}", payload.status));
                    }
                    if (!payload) return;

                    if (payload.status != null && payload.status !== constants.STATUS_SUCCESS) {
                        return;
                    }

                    const list =
                        Array.isArray(payload) ? payload :
                        (Array.isArray(payload.urlList) ? payload.urlList : null);

                    if (!Array.isArray(list)) return;

                    const nextMap = { ...(this.thumbnailUrlByData || {}) };
                    const nextFailed = { ...(this.thumbnailFailedByData || {}) };
                    for (const item of list) {
                        if (!item || !item.data || !item.url) continue;
                        nextMap[item.data] = item.url;
                        if (nextFailed[item.data]) {
                            delete nextFailed[item.data];
                        }
                    }
                    this.thumbnailUrlByData = nextMap;
                    this.thumbnailFailedByData = nextFailed;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "getThumbnailUrls", error);
                });
        },
        /**
         * Return the cached thumbnail URL for a row (empty string if none).
         */
        getCachedThumbnailUrl(row) {
            if (!row || !row.data) return '';
            return (this.thumbnailUrlByData && this.thumbnailUrlByData[row.data]) ? this.thumbnailUrlByData[row.data] : '';
        },
        /**
         * Resolve the `<img>` src for a media thumbnail with url or placeholder image
         */
        getMediaThumbnailSrc(row) {
            if (!row || !row.data) return '';

            const isVideo = this.isVideo(row.type, row.data);
            const isImage = this.isImage(row.type, row.data);
            if (!isVideo && !isImage) return '';

            const url = this.getCachedThumbnailUrl(row);
            const failed = !!(this.thumbnailFailedByData && this.thumbnailFailedByData[row.data]);
            if (url && !failed) return url;

            return isVideo
                ? require('../../assets/icon_movie_placeholder.svg')
                : require('../../assets/icon_image_placeholder.svg');
        },
        /**
         * Mark a thumbnail as failed to load for this row so we can fall back to placeholders.
         */
        onMediaThumbnailError(row) {
            if (!row || !row.data) return;
            const next = { ...(this.thumbnailFailedByData || {}) };
            next[row.data] = true;
            this.thumbnailFailedByData = next;
        },
        /**
         * For hiding video overlay when using placeholder
         */
        hasLoadedThumbnail(row) {
            if (!row || !row.data) return false;
            const url = this.getCachedThumbnailUrl(row);
            const failed = !!(this.thumbnailFailedByData && this.thumbnailFailedByData[row.data]);
            return !!url && !failed;
        },
        clickPlay(talkrecord, event) {
            let img = event.target
            let audio = document.getElementById('record-player');

            if (this.notSupportAgent) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_not_support_play_talk"));
                return;
            }

            if (this.currentPlayingButton !== null) {
              audio.pause();
                if (!isNaN(audio.duration)) {
                    audio.currentTime = 0;
                }
              if (this.currentPlayingButton === event.target) {
                return ;
              }
            }

            let self = this;
            let endpoint;
            let input;
            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    tenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                };
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if(res.data.status != 0){
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_play_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_no_speech_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","clickPlay").replace("{code}",res.data.status));
                                break;
                        }
                        return;
                    }

                    img.src = require('../../assets/icon_stop.svg')
                    self.currentPlayingButton = event.target;

                    // talkgroup: new specification using urlList
                    // p2p: old specification using urls
                    audio.src = res.data.urlList[0].url;
                    audio.play();
                    audio.addEventListener("pause", function(){
                        self.currentPlayingButton = null;
                        img.src = require('../../assets/icon_start.svg')
                    }, false);
                    audio.addEventListener("ended", function(){
                        self.currentPlayingButton = null;
                        img.src = require('../../assets/icon_start.svg')
                    }, false);
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "clickPlay", error);
                });
        },
        getBinaryData(talkrecord) {
            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Preparing the data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let self = this;
            let endpoint;
            let input;
            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    tenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ]
                };
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if(res.data.status != 0){
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_play_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_no_video_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getBinaryData").replace("{code}",res.data.status));
                                break;
                        }
                        self.closeLoadingScreen();
                        return;
                    }
                    self.closeLoadingScreen();
                    if (self.isVideo(talkrecord.type, talkrecord.data)) {
                        self.playVideoSrc = res.data.urlList[0].url;
                        self.showVideoPlayer = true;
                    } else if (this.isPDF(talkrecord.type, talkrecord.data)) {
                        this.pdfSrc = res.data.urlList[0].url;
                        this.showPDFViewer = true;
                    } else {
                        self.imageSrc = res.data.urlList[0].url;
                        self.showImageViewer = true;
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getBinaryData", error);
                });
        },
        getEmptyTalkRecordText() {
            if (this.displayInitialNotice) {
                return " ";
            } if ((this.selected === null) || (this.selected.length === 0)) {
                return commonUtil.getMessageText(this.$i18n,"info_please_select_group_or_talkers");
            } else {
                if (this.isTalkgroup) {
                    return commonUtil.getMessageText(this.$i18n,"info_group_talk_not_found");
                } else {
                    if (this.selected.length < 2) {
                        return commonUtil.getMessageText(this.$i18n,"info_please_select_talkers");
                    } else {
                        return commonUtil.getMessageText(this.$i18n,"info_individual_talk_not_found");
                    }
                }
            }
        },
        checkHiddenData({row}){
            if (row.hidden){
                return 'hiddenData-row';
            }else{
                return 'showData-row';
            }
        },
        handleTalkrecordsCSVExportAuditLogError(auditLogStatus) {
            if (auditLogStatus === undefined) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "info_no_talk_record_list"));
                return;
            }

            switch (auditLogStatus) {
                case constants.STATUS_ERROR_INVALID_PARAMETER:
                case constants.STATUS_ERROR_DENIED:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                    break;
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_object_not_found_talkgroup"));
                    break;
                case constants.STATUS_ERROR_PERMISSION_DENIED:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_operate_no_tenantAdmin_privilege"));
                    break;
                case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_tenant_already_deleted_general"));
                    break;
                default:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "registerTalkrecordsCSVExportAuditLog").replace("{code}", auditLogStatus));
                    break;
            }
        },
        async exportToCSV() {
            if (FEATURE_C2C_AUDIT_LOG) {
                if (this.isTalkgroup) {
                    const auditLogStatus = await this.registerTalkrecordsCSVExportAuditLog();
                    if (auditLogStatus !== constants.STATUS_SUCCESS) {
                        this.handleTalkrecordsCSVExportAuditLogError(auditLogStatus);
                        return;
                    }
                }
            }

            let universalBOM = "\uFEFF";
            let csvData = commonUtil.getMessageText(this.$i18n,"title_csv_talkList_notice");
            csvData += commonUtil.getMessageText(this.$i18n,"title_csv_talkList_header");
            for (let talkrecord of this.talkrecords) {
                csvData += commonUtil.getFormattedLocalDatetime(talkrecord.startTime) + ",";
                if (talkrecord.type == constants.TALK_RECORD_VOICE || this.isVideo(talkrecord.type, talkrecord.data)) {
                    csvData += (talkrecord.duration/1000) + ",";
                } else {
                    csvData += "N/A,";
                }

                csvData += '"' + talkrecord.displayName.replace(/"/g, '""') + '"' + ",";

                switch(talkrecord.type) {
                    case constants.TALK_RECORD_VOICE:
                        if (talkrecord.attributes === constants.TALK_RECORD_ATTRIBUTE_VOICE_REPORT) {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_voice_report") + ",";
                        }else{
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_voice") + ",";
                        }
                        break;
                    case constants.TALK_RECORD_TEXT:
                        csvData += commonUtil.getMessageText(this.$i18n,"item_type_text") + ",";
                        break;
                    case constants.TALK_RECORD_BINARY:
                        if (this.isVideo(talkrecord.type, talkrecord.data)) {
                            csvData += commonUtil.getMessageText(this.$i18n, "item_type_video") + ",";
                        } else if (this.isPDF(talkrecord.type, talkrecord.data)) {
                            csvData += "PDF,";
                        } else {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_image") + ",";
                        }
                        break;
                    case constants.TALK_RECORD_ONLOAD_DATA:
                        if (talkrecord.isMml) {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_melody_stamp") + ",";
                        } else {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_etc") + ",";
                        }
                        break;
                }
                if (talkrecord.data == null || talkrecord.type == constants.TALK_RECORD_BINARY) {
                    csvData += '"N/A"';
                } else {
                    csvData += '"' + talkrecord.data.split('"').join("'") + '"';
                }
                csvData += "\n";
            }
            let blob = new Blob([universalBOM + csvData], { type: 'application/csv;charset=UTF-8' })
            let downloadFileName = "talkRecordList.csv"
            commonUtil.downloadFile(blob, downloadFileName)
        },
        async registerTalkrecordsCSVExportAuditLog() {
            if (this.talkrecords.length === 0) {
                return undefined;
            }

            try {
                const res = await server.post("/talkrecordscsvexportauditlog", {
                    talkgroupTenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    fromId: this.talkrecords.reduce((acc, t) => Math.min(acc, t.id), this.talkrecords[0].id),
                    toId: this.talkrecords.reduce((acc, t) => Math.max(acc, t.id), this.talkrecords[0].id),
                    interestLanguageIndex: this.selectedLanguageIndex,
                    recordCount: this.talkrecords.length,
                });
                return res.data.status;
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "registerTalkrecordsCSVExportAuditLog", e, "warn");
            }
            return constants.STATUS_ERROR_UNKNOWN;
        },
        handleChangeLanguage() {
            if (this.talkrecords.length > 0) {
                this.getList(false);
            }
        },
        isVoiceReport(type, attributes) {
            return type === this.Const.TALK_RECORD_VOICE && attributes === constants.TALK_RECORD_ATTRIBUTE_VOICE_REPORT;
        },
        isVideo(type, data) {
            return commonUtil.isVideo(type, data);
        },
        isImage(type, data) {
            return commonUtil.isImage(type, data);
        },
        isPDF(type, data) {
            return commonUtil.isPDF(type, data);
        },
        isMapTalk(type, attributes) {
            return type === this.Const.TALK_RECORD_VOICE && (attributes & constants.TALK_RECORD_ATTRIBUTE_MAP) !== 0 && FEATURE_C2C_MAP_TALK;
        },
        getCellClassName({ row, column }) {
            if (!row || !column) return '';

            // Apply only to the Talk Text / Data column
            if (column.property === 'data' && (this.isVideo(row.type, row.data) || this.isImage(row.type, row.data))) {
                return 'is-thumbnail-cell';
            }

            return '';
        },
        showDetailWindow(talkrecord) {
            this.showDetail = true;
            this.detailShownRecord = talkrecord;
        },
        getDisplayDatetime(utcTime) {
            commonUtil.getFormattedLocalDatetime(utcTime);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        checkTalkRecordList() {
            console.log(this.$refs.talkRecordsTable.data.length)
            if (this.$refs.talkRecordsTable.data.length === this.talkrecords.length) {
                clearInterval(this.timer);
                this.timer = null;
                this.loading = false;
                commonUtil.notifyMessage(this,"Success",commonUtil.getMessageText(this.$i18n,"info_refresh_talk_list"));
            }
        },
        setTimer: function() {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(this.checkTalkRecordList, 100);
        },
        convertMillsec: function(duration) {
            return commonUtil.convertMillsec(duration);
        },
    },
    watch: {
        date: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        startTime: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        endTime: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        selected: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        languageIndex: {
            handler(newVal, oldVal) {
               this.selectedLanguageIndex = newVal;
               return this.getList(false);
            }
        },
        '$route' (to, from) {
            if (to.name === "Talk") {
                this.initTalkRecordListPanel();
            }
        }
    },
    created () {
        this.currentPlayingButton = null;
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf('msie') > 0 ) || (userAgent.indexOf('trident') > 0 )) {
            this.notSupportAgent = true;
        }
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        this.selectedLanguageIndex = this.languageIndex;
    },
    mounted() {
        this.initTalkRecordListPanel();
        this.getList(true);
    },
    components: {
        PDFViewer,
        VideoPlayer,
        ImageViewer,
        TalkrecordDetail
    },
    props: [ 'appData', 'date', 'startTime', 'endTime', 'languageIndex', 'selected', 'isTalkgroup' ]
}

</script>

<style>
tr.talkrecord-header > th {
    color: #848991;
    font-size: 12px;
    background-color: #f6f6f6;
    padding-top: 0px;
    padding-bottom: 0px;
}
tr.hiddenData-row {
    background: #cfcfcf;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: unset;
}
tr.hiddenData-row {
    background: #dddddd;
}
tr.hiddenData-row:hover {
    background-color: #cfcfcf;
}
tr.showData-row {
    background: #ffffff;
}
tr.showData-row:hover {
    background-color: #ecf1fa;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.talkrecord-list-root {
    height: 100%;
    min-height: 0;
    min-width: 0;
}

.talkrecord-list-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    min-width: 0;
}

.talkrecord-table-wrap {
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding-bottom: 14px;
    box-sizing: border-box;
}

.talkrecord-table-wrap >>> .el-table {
    height: 100% !important;
}

table {
    border-collapse: collapse;
}
tr.talk-record {
    border-bottom: 1px solid #eee;
}
tr.talk-record {
    border-bottom: solid;
    border-width: 1px;
    border-color: #eee;
    padding-left: 20px;
}
td.record-starttime {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-displayname {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-data {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.notalkrecord {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 10vh;
    opacity: 0.6;
}
.object-titlebox-right >>> .el-select .el-input {
    font-size: 12px;
    width: 130px;
}
.object-titlebox-right >>> .el-input__inner {
    height: 30px;
}
.object-titlebox-right >>> .el-input__icon {
    line-height: 30px;
}
.el-table:before {
    background-color: #ffffff;
}
.el-table >>> .cell {
    word-break: normal;
}
.el-table >>> .el-table__cell.is-thumbnail-cell .cell {
    padding-left: 8px;
    padding-right: 8px;
    line-height: 0;
}
.el-table >>> .el-table__cell.is-thumbnail-cell {
    padding: 2px 0;
}
.talkrecord-thumbnail {
    max-width: 140px;
    max-height: 64px;
    width: auto;
    height: auto;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    object-fit: cover;
}
.talkrecord-thumbnail-wrapper {
    display: inline-block;
    position: relative;
    cursor: pointer;
    line-height: 0;
}
.talkrecord-thumbnail-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
}
.talkrecord-thumbnail-play {
    position: absolute;
    inset: 0;
    margin: auto;
    width: 34px;
    height: 34px;
    padding: 0;
    border: none;
    background: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
}
.talkrecord-thumbnail-play img {
    width: 18px;
    height: 18px;
}
</style>
